import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const cole2020 = {
  citation:
    "Cole EJ, et al. Stanford Accelerated Intelligent Neuromodulation Therapy for Treatment-Resistant Depression. Am J Psychiatry. 2020;177(8):716-726.",
  url: "https://doi.org/10.1176/appi.ajp.2019.19070720",
};
const cole2022 = {
  citation:
    "Cole EJ, et al. Stanford Neuromodulation Therapy (SNT): A Double-Blind Randomized Controlled Trial. Am J Psychiatry. 2022;179(2):132-141.",
  url: "https://doi.org/10.1176/appi.ajp.2021.20101429",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Qué rápido funciona SAINT®?",
    answer:
      "SAINT® se administra durante cinco días. En los estudios de Stanford, una proporción de los participantes alcanzó la remisión tras los cinco días (Cole et al., Am J Psychiatry 2020; 2022). Los resultados individuales pueden variar y no están garantizados.",
  },
  {
    question: "¿SAINT® es más rápido que la TMS convencional?",
    answer:
      "SAINT® se completa en cinco días, mientras que la TMS convencional suele durar seis semanas. La rapidez es una de las diferencias clave entre ambos enfoques.",
  },
];

export const esHowFast = makeEsArticle({
  slug: "how-fast-does-saint-tms-work",
  title: "¿Qué tan rápido funciona SAINT® TMS?",
  description:
    "¿Qué tan rápido funciona SAINT® TMS? SAINT® se administra durante cinco días. En los estudios de Stanford, una proporción de los participantes alcanzó la remisión tras los cinco días. Los resultados individuales pueden variar.",
  h1: "¿Qué tan rápido funciona SAINT® TMS?",
  breadcrumbLabel: "¿Qué tan rápido funciona SAINT® TMS?",
  shortAnswer:
    "SAINT® se administra durante cinco días consecutivos. En los estudios de Stanford, una proporción de los participantes alcanzó la remisión tras los cinco días (Cole et al., Am J Psychiatry 2020; 2022). Los resultados individuales pueden variar y no están garantizados. La TMS convencional, en comparación, suele durar seis semanas.",
  keyTakeaways: [
    "SAINT® se administra durante cinco días.",
    "Una proporción de los participantes alcanzó la remisión tras cinco días en los estudios de Stanford.",
    "Los resultados individuales pueden variar y no están garantizados.",
    "La TMS convencional suele durar seis semanas.",
    "La rapidez es una de las diferencias clave entre SAINT® y la TMS convencional.",
  ],
  sections: [
    {
      heading: "El calendario de cinco días",
      paragraphs: [
        "SAINT® se administra durante cinco días consecutivos, con diez sesiones por día. Este calendario acelerado es una de las diferencias principales frente a la TMS convencional, que suele durar seis semanas.",
      ],
    },
    {
      heading: "Resultados en los estudios",
      paragraphs: [
        "En los estudios de Stanford, una proporción de los participantes alcanzó la remisión tras los cinco días (Cole et al., Am J Psychiatry 2020; 2022). Estos resultados son de estudios de investigación; los resultados individuales pueden variar y no están garantizados.",
      ],
    },
    {
      heading: "Lo que significa para usted",
      paragraphs: [
        "La rapidez de SAINT® puede ser relevante si desea un tratamiento intensivo de corta duración. La idoneidad se confirma mediante una evaluación psiquiátrica. [[Solicite una consulta|/es/saint]] o llame al 954-827-9793.",
      ],
    },
  ],
  faqs,
  sources: [cole2020, cole2022],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
